import React, { useState } from "react";
import axios from "axios";
import { Button, Tooltip, message } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { API_DOMAIN } from "../constants";
import { CustomerEditDrawer } from "./CustomerEditDrawer";

export function CustomerProfileButton({ phone, size = "small" }) {
  const [customer, setCustomer] = useState(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchAndOpen = async () => {
    if (!phone) return;
    setLoading(true);
    const headers = { accessToken: localStorage.getItem("accessToken") };
    try {
      const res = await axios.get(API_DOMAIN + "/customers/get_full_profile", { params: { phone }, headers });
      if (res.data.success && res.data.data?.length > 0) {
        setCustomer(res.data.data[0]);
        setOpen(true);
        return;
      }
      await axios.post(API_DOMAIN + "/whatsapp/customer_add", { name: phone, number: phone }, { headers });
      message.success("Saved the customer automatically");
      const refetch = await axios.get(API_DOMAIN + "/customers/get_full_profile", { params: { phone }, headers });
      if (refetch.data.success && refetch.data.data?.length > 0) {
        setCustomer(refetch.data.data[0]);
        setOpen(true);
      } else {
        message.error("Could not load customer profile");
      }
    } catch (e) {
      message.error(e.message || "Failed to load customer profile");
    } finally {
      setLoading(false);
    }
  };

  // A single wrapping element (not a Fragment) so this component is always
  // exactly one flex item wherever it's embedded — a Fragment here would
  // flatten the Drawer's stopPropagation div in as a second, invisible flex
  // sibling next to the button, throwing off flex layouts like
  // justifyContent: space-between in the host row.
  return (
    <span onClick={e => e.stopPropagation()} style={{ display: "inline-flex" }}>
      <Tooltip title="Open customer profile">
        <Button
          type="text"
          size={size}
          loading={loading}
          icon={<UserOutlined />}
          onClick={fetchAndOpen}
          style={{ padding: "0 4px" }}
        />
      </Tooltip>
      {/* antd's Drawer portals to document.body, but React still bubbles its
          synthetic events up the *component* tree, not the DOM tree — so any
          click inside here (closing it, editing a field, etc.) would
          otherwise reach whatever onClick the host card/row has. The outer
          span's stopPropagation covers this too. */}
      <CustomerEditDrawer
        customer={customer}
        open={open}
        defaultTab="customer"
        onClose={() => setOpen(false)}
        onSaved={updated => setCustomer(updated)}
      />
    </span>
  );
}
